import { Mail, Handshake, CalendarCheck, AlertTriangle } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    num: "01",
    icon: Mail,
    title: "Send an email",
    text: "Email us and tell us you'd like lessons — your level, the dialect you want and your goals.",
  },
  {
    num: "02",
    icon: Handshake,
    title: "Mutual agreement",
    text: "Together we agree on your paid hours — 6, 12 or 30 hours — and the plan that suits you.",
  },
  {
    num: "03",
    icon: CalendarCheck,
    title: "Start learning",
    text: "Lessons of 90 minutes to 2 hours, scheduled flexibly — any time that works for you.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <p className="eyebrow">The process</p>
        <h2 className="mt-3 font-serif text-3xl tracking-tight text-ink sm:text-4xl md:text-5xl">
          How it works
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-10 md:grid-cols-3 md:gap-8">
        {STEPS.map((step, i) => (
          <Reveal key={step.num} delay={i * 0.12}>
            <div className="group border-t-2 border-pine/15 pt-6 transition-colors duration-300 hover:border-jade">
              <div className="flex items-center justify-between">
                <p className="font-mono text-sm text-gold">{step.num}</p>
                <step.icon className="h-5 w-5 text-pine/50 transition-colors duration-300 group-hover:text-jade" />
              </div>
              <h3 className="mt-5 font-serif text-2xl text-ink">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-soft">{step.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-16 flex flex-col gap-5 rounded-3xl border border-jade/30 bg-jade-light p-8 md:flex-row md:items-center md:p-10">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-pine text-paper">
            <AlertTriangle className="h-5 w-5" />
          </span>
          <div>
            <h3 className="font-serif text-xl text-ink">Cancellation policy</h3>
            <p className="mt-2 max-w-3xl text-sm leading-relaxed text-ink-soft md:text-base">
              To cancel or move a lesson, we must be notified at least 48 hours before it
              starts. Without 48 hours&apos; notice, the lesson cannot be refunded.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default HowItWorks;
